module.exports = __webpack_public_path__ + "static/media/14122018-2.fbaeb2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/14122018-2.png
// module id = 1668
// module chunks = 0